import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./Component/Footer";
import { Navbar } from "./Component/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/main.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
import Home from "./Container/Home";
import Aos from "aos";
import "aos/dist/aos.css";
import Privacy from "./Container/Privacy";
import HapusData from "./Container/HapusData";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <Router>
      {/* <Suspense fallback={<div id="preloader"></div>}> */}
      {/* <Header /> */}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kebijakan-privasi" element={<Privacy />} />
        <Route path="/hapus-data" element={<HapusData />} />
      </Routes>
      <Footer />
      {/* </Suspense> */}
    </Router>
  );
}

export default App;
